import { useEffect } from "react";

/**
 * Enter отправляет форму, даже если фокус ушёл из её полей (на галочку или на страницу).
 * Ссылки, кнопки и поля вне формы (поиск в шапке) Enter обрабатывают сами.
 */
export function useEnterSubmit(formRef, enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (event) => {
      if (event.key !== "Enter" || event.defaultPrevented || event.isComposing) return;
      const form = formRef.current;
      const target = event.target;
      if (!form || target.closest?.("a, button, textarea, select")) return;
      if (target !== document.body && !form.contains(target)) return;
      event.preventDefault();
      form.requestSubmit();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [formRef, enabled]);
}
